import { render } from "./LegacySystemHealthReportSettings.vue?vue&type=template&id=2d22bdf4"
import script from "./LegacySystemHealthReportSettings.vue?vue&type=script&lang=js"
export * from "./LegacySystemHealthReportSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__